import React from "react"
import Game from "./Game"

import Error from "./../general/Error"

import { withRouter } from "react-router"
import { has } from "lodash"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

class Console extends React.Component{
    constructor(){
        super()
        this.state={
            isLoading: true,
            data: null,
            games: null,
            reviews: null,
            error: ""
        }
    }
    componentDidMount(){
        fetch("/api/data/project/list")
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({ 
                data: data.results, 
                games: data.results.map(project => <Game imgUrl={`/api/store/project/${project.id}/image`} 
                    key={project.id} id={project.id} userId={this.props.match.params.id} appConfig={project.app_configs} 
                    gameName={project.name} isPrivate={project.private} isPublic={project.public}
                    createdAt={project.createdAt} updatedAt={project.updatedAt} greenlit={project.greenlit}
                    upvoteCount={project.upvoteCount} reviewCount={project.reviewCount} />
                ),
                isLoading: false
            })
        })
        .catch(data =>{
            this.setState({
                error: `Server: ${data.error}`,
                isLoading: false
            })
        })
    }
    render(){
        if (this.state.error !== ""){
            return(
                <Error error={this.state.error} />
            )
        }
        return(
            <div className={this.state.isLoading === true? "loadingWrapper" : "mainContent"}>
                {this.state.isLoading === true
                ? <h3 className="loading"><FontAwesomeIcon icon={faSpinner} spin /></h3>
                : <div className="console">
                    <h3>I have made...</h3>
                    {this.state.games}
                </div>}
            </div>
        )
    }
}

export default withRouter(Console)